import React from 'react';
import { Typography } from 'antd';
import { VideoIcon } from '../../assets/icons';

const { Text } = Typography;

const RecordBox = ({
    disabled,
    onClick,
    borderColor
}) => (
    <div
        style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: "center",
            cursor: disabled ? 'not-allowed' : 'pointer',
            border: `1px dashed ${borderColor}`,
            borderRadius: 6,
            // padding: '30px 60px',
            width: "250px",
            height: "104px",
            backgroundColor: 'rgba(0, 0, 0, 0.02)',
        }}
        onClick={onClick}
    >
        <div
            style={{
                height: 25,
                width: 25,
                marginBottom: 10,
                color: '#375BFB',
            }}
        >
            <VideoIcon />
        </div>
        <Text style={{ fontSize: 16, color: '#375BFB' }}>Record Video</Text>
    </div>
);

export default RecordBox;
